class optPravci {
    constructor(odtacke, dotacke) {
        this.odtacke = odtacke;
        this.dotacke = dotacke;
    }
}

export { optPravci as default }